<template>
  <Portal to="modal-simple-video">
    <div class="fixed inset-0 bg-gray-100">
      <div class="close absolute p-6 bg-gray-100 right-0 top-0 z-20 cursor-pointer" @click="$emit('close')">
        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="0.646447" y1="21.1533" x2="21.1525" y2="0.647188" stroke="white" />
          <line
            y1="-0.5"
            x2="29"
            y2="-0.5"
            transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 21.5078 21.5061)"
            stroke="white"
          />
        </svg>
      </div>
      <div class="iframe-video" v-html="iframeHtml"></div>
    </div>
  </Portal>
</template>

<script>
export default {
  name: 'SimpleVideo',
  props: {
    iframeHtml: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="postcss" scoped>
.iframe-video ::v-deep iframe {
  width: 100vw;
  height: 100vh;
}
.close {
  svg {
    @apply transition ease-in duration-300 opacity-60;
  }
  &:hover {
    svg {
      @apply rotate-[270deg] opacity-100;
    }
  }
}
</style>
